module.exports = __webpack_public_path__ + "130700bffde57525685499dd7e871f61.png";